const textSection = (editor) => {

    editor.BlockManager.add(`text-section`, {
        category: 'Typography',
        label: 'Text section',
        attributes: { class: 'gjs-fonts gjs-f-h1p' },
        content: `<div class="bdg-sect">
            <h1 class="heading p-2 m-0">Insert title here</h1>
            <p class="paragraph p-2 m-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
            </div>`
    });
}

export default textSection;